export default class Result {
    constructor(text, ot_val, do_val) {
        this.text = text;
        this.ot = ot_val;
        this.do = do_val;
    }

    //Этот метод проверяет, достаточно ли очков набрал пользователь
    Check(value) {
        if (this.ot <= value && this.do >= value) {
            return true;
        } else {
            return false;
        }
    }
}